import PaymentHelper from "@/utils/payment-helper"

export default class Stripe {

    static get(pm, paymentData, store) {
        switch(pm.type) {
            case 'direct_debit':
                return Stripe.directDebit(pm, paymentData, store);
        }
    }

    static directDebit(pm, paymentData, store) {
        const scheme = pm.configuration.scheme;
        switch (scheme) {
            case 'BACS':
            case 'BECS':
                return Stripe.bacsAndBecs(paymentData, store);
        }
    }

    static bacsAndBecs(paymentData, store) {
        const { company, first_name, last_name, email, routing_number, account_number } = paymentData
        return {
            customer: {
                firstName: first_name,
                lastName: last_name,
                company,
                email,
                billingAddress: PaymentHelper.getCustomerBillingAddress(store)
            },
            bankAccount : {
                accountNumber: account_number,
                routingNumber: routing_number,
            }
        }
    }

}